<div @fadeInOut class="fld-col ai-ctr pwy-7 pwx-5 mwtr-p10 mwt-7">
  <mat-spinner></mat-spinner>
  <ng-content></ng-content>
</div>
